<template>
  <crud-editor
    ref="editor"
    :show-delete-button="false"
    :show-save-and-next-button="false"
    :is-edit="true"
    :definition="definition"
    :fetch-by-id="fetchById"
    :disabled="hasNoEditPermission"
    :save="saveData"
    :return-to="returnTo"
    :item-type="entity"
    :page-loading="loading"
    :get-layout="layout"
  />
</template>

<script>
import CrudEditor from '@/components/crud/TabbedEditor';
import formMixin from './form-mixin';
import { hasEditPermissionForCode } from '@/utils/permission';
import { getEditLayoutDefinition } from './form.js';

export default {
  components: {
    CrudEditor
  },
  mixins: [formMixin],
  data() {
    return {
      layout: getEditLayoutDefinition
    };
  },
  computed: {
    hasNoEditPermission() {
      return !hasEditPermissionForCode('Domain', this.$store.getters.permissions);
    },
    loading() {
      return this.$store.getters[this.entityStore + '/isLoading'];
    }
  },
  async created() {
    await Promise.all([this.$store.dispatch('finish/getItems'), this.$store.dispatch('finishType/getItems')]);
  },
  methods: {
    fetchById(id) {
      const productGroupID = this.$route.params.productGroupID;
      const domainID = +this.$route.params.id || parseInt(this.$route.params.domainID);
      return this.$store
        .dispatch(this.entityStore + '/getItemByDomainAndProductGroup', { domainID, productGroupID })
        .then(item => this.createFormDataFromItem(this, item));
    },
    saveData(form) {
      const item = this.createItemFromFormData(this, form);
      item.domainID = parseInt(this.$route.params.domainID);
      item.productGroupID = this.$route.params.productGroupID;
      return this.$store.dispatch(this.entityStore + '/persistItem', item);
    }
  }
};
</script>
